import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Projects/Plans/tables";
import headers from "../../../../Data/Tables/Projects/Plans/headers";
import { get_all_project_plans } from "../../../../Controllers/Projects/Plans";
import Loadercomponent from "../../../../Components/Loader";
import Table from "../../../../Components/Table";
import Header from "../../../../Components/Header";
import ActionButton from "../../../../Components/Buttons/action";
import TableImage from "../../../../Components/Tableimage";
import Status from "../../../../Components/Status";
import URL from "../../../../Main/url";

const ProjectPlansTable = () => {
  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();

  const formdata = (data) => {
    fetchData(data);
  };

  const actiondata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        status: tabledata?.status,
      };

      const plans = await get_all_project_plans(params);

      if (plans?.status) {
        let data = [];

        plans?.data?.map((value, index) => {
          data?.push({
            Name: (
              <TableImage
                image={URL + "/uploads" + value?.image}
                name={value?.name}
              />
            ),
            Description: value?.description,
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/projects/plans/edit/${value?._id}`}
                id={value?._id}
                api="delete-project-plan"
                actiondata={actiondata}
              />
            ),
          });
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(plans?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header header={headers} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table head={tables} body={body} />
      </Loadercomponent>
    </Header>
  );
};

export default ProjectPlansTable;
